import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Tummy Tuck Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MD - Dermatology, Fellowship in Cosmetic Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Abdominoplasty Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Tummy Tuck Expert"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Dermatology, Fellowship in Aesthetic Medicine",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Mommy Makeover Specialist"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Fleur-de-Lis Tummy Tuck Expert"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, DNB - Plastic Surgery",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Cosmetic Abdominoplasty Specialist"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Tummy Tuck Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert surgical care for comprehensive abdominal contouring with muscle repair and excess skin removal.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const TummyTuckSurgery = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Tummy Tuck Surgery
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Complete Abdominal Contouring with Muscle Repair. Permanent Solution for Excess Skin and Stubborn Fat.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Mommy Makeover Consultation
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>98%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Patient Satisfaction Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>2-5</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Hours Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>4-8</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Weeks Full Recovery</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>{`<2%`}</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Complication Rate</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "benefits", label: "Benefits", icon: "🔍" },
              { id: "types", label: "Procedure Types", icon: "🎯" },
              { id: "procedure", label: "Procedure", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "results", label: "Results", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Tummy Tuck Surgery</span>
            </h2>
          </div>

          {/* What is Tummy Tuck */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Tummy Tuck (Abdominoplasty)
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                A tummy tuck, medically known as abdominoplasty, is a comprehensive cosmetic surgical procedure 
                designed to remove excess skin and fat from the abdominal area while tightening weakened or 
                separated abdominal muscles. This procedure creates a smoother, firmer abdominal profile that 
                diet and exercise alone cannot achieve.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Ideal Candidates</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Men and women with excess abdominal skin, stubborn fat deposits, weakened abdominal 
                      muscles from pregnancy or weight loss, and those seeking improved abdominal contour.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Comprehensive Results</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Addresses multiple concerns simultaneously: excess skin removal, fat reduction, 
                      muscle repair, and overall abdominal contouring for transformative results.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Benefits & Advantages */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Benefits & Advantages
            </h3>

            <div className="row">
              {[
                {
                  title: "Muscle Repair", 
                  description: "Corrects diastasis recti (separated abdominal muscles) for core strength restoration",
                  details: "Especially beneficial post-pregnancy"
                },
                {
                  title: "Excess Skin Removal", 
                  description: "Eliminates hanging skin that doesn't respond to diet and exercise",
                  details: "Permanent solution for loose skin"
                },
                {
                  title: "Improved Contour", 
                  description: "Creates flatter, more toned abdominal appearance with natural-looking results",
                  details: "Enhanced body proportions"
                },
                {
                  title: "Clothing Fit", 
                  description: "Better fitting clothes and increased confidence in various outfits",
                  details: "Expanded fashion options"
                },
                {
                  title: "Posture Improvement", 
                  description: "Tightened abdominal muscles can improve overall posture and reduce back pain",
                  details: "Functional and aesthetic benefits"
                },
                {
                  title: "Long-lasting Results", 
                  description: "Permanent improvement maintained with stable weight and healthy lifestyle",
                  details: "Lifetime benefits with proper maintenance"
                }
              ].map((benefit, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {benefit.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {benefit.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {benefit.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Tummy Tuck Types & Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Tummy Tuck Types & Options
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Full Tummy Tuck",
                    description: "Comprehensive procedure addressing upper and lower abdomen with muscle repair and belly button repositioning",
                    treatment: "Ideal for significant weight loss or multiple pregnancies"
                  },
                  {
                    type: "Mini Tummy Tuck",
                    description: "Limited to lower abdomen below navel, shorter scar, faster recovery for mild cases",
                    treatment: "Suitable for minor skin laxity below belly button"
                  },
                  {
                    type: "Extended Tummy Tuck",
                    description: "Addresses abdomen plus love handles and upper hips for complete torso contouring",
                    treatment: "Comprehensive body contouring solution"
                  },
                  {
                    type: "Fleur-de-Lis Tummy Tuck",
                    description: "Vertical and horizontal skin removal for massive weight loss patients with extreme excess skin",
                    treatment: "Maximum skin removal for dramatic results"
                  },
                  {
                    type: "Circumferential Tummy Tuck",
                    description: "360-degree body lift addressing entire torso circumference including back and flanks",
                    treatment: "Complete lower body contouring"
                  },
                  {
                    type: "Reverse Tummy Tuck",
                    description: "Focuses on upper abdomen only, often combined with breast surgery",
                    treatment: "Upper abdominal contouring"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Candidates & Considerations */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Ideal Candidates & Considerations
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Ideal Candidates</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Men and women in good overall health</li>
                      <li style={{ marginBottom: "10px" }}>Individuals with significant abdominal skin laxity</li>
                      <li style={{ marginBottom: "10px" }}>Post-pregnancy women with separated abdominal muscles</li>
                      <li style={{ marginBottom: "10px" }}>Massive weight loss patients with excess skin</li>
                      <li>Those at stable weight for 6+ months</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Important Considerations</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Realistic expectations about scarring and results</li>
                      <li style={{ marginBottom: "10px" }}>Non-smokers or willing to quit before and after surgery</li>
                      <li style={{ marginBottom: "10px" }}>No plans for future pregnancies</li>
                      <li style={{ marginBottom: "10px" }}>Commitment to maintaining stable weight</li>
                      <li>Understanding of recovery timeline and restrictions</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Surgical Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Standard Tummy Tuck Procedure
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    The comprehensive tummy tuck addresses multiple abdominal concerns through a 
                    systematic approach that combines skin removal, fat reduction, and muscle repair.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Key Components:</h6>
                    <div className="row">
                      <div className="col-12">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}><strong>Muscle Repair:</strong> Tightening of separated abdominal muscles (diastasis recti)</li>
                          <li style={{ marginBottom: "8px" }}><strong>Skin Excision:</strong> Removal of excess stretched skin from lower abdomen</li>
                          <li style={{ marginBottom: "8px" }}><strong>Liposuction:</strong> Contouring of abdominal area and flanks</li>
                          <li style={{ marginBottom: "8px" }}><strong>Belly Button Repositioning:</strong> Creating natural-looking navel appearance</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}><strong>Progressive Tension Sutures:</strong> Reduces tension on incision and seroma risk</li>
                      <li style={{ marginBottom: "8px" }}><strong>Drain-free Techniques:</strong> Advanced closure methods eliminating need for drains</li>
                      <li style={{ marginBottom: "8px" }}><strong>Scar Placement:</strong> Strategic incision placement for optimal concealment</li>
                      <li><strong>Layered Closure:</strong> Multiple tissue layer repair for durable results</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Combination Procedures
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Mommy Makeover:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Tummy tuck combined with breast augmentation/lift</li>
                      <li style={{ marginBottom: "10px" }}>Comprehensive post-pregnancy body restoration</li>
                      <li style={{ marginBottom: "10px" }}>Addresses multiple concerns in single recovery period</li>
                      <li style={{ marginBottom: "10px" }}>Customized based on individual needs and goals</li>
                      <li>Most popular combination for comprehensive results</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Additional Combinations:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Tummy tuck with liposuction of flanks and back</li>
                      <li style={{ marginBottom: "10px" }}>Circumferential body lift for massive weight loss</li>
                      <li style={{ marginBottom: "10px" }}>Fleur-de-Lis with arm or thigh lift</li>
                      <li style={{ marginBottom: "10px" }}>Reverse tummy tuck with breast reduction</li>
                      <li>Mini tummy tuck with labiaplasty</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>High-definition liposuction for abdominal etching</li>
                      <li style={{ marginBottom: "10px" }}>Scar minimization strategies</li>
                      <li>Rapid recovery protocols for faster healing</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Surgical Procedure Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Surgical Procedure & Recovery Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Week 1-2",
                    title: "Initial Recovery",
                    activities: ["Drain care and monitoring", "Limited mobility and bending", "Pain management", "Compression garment wearing"]
                  },
                  {
                    period: "Week 3-4",
                    title: "Early Healing",
                    activities: ["Gradual increase in activity", "Drain removal if present", "Swelling reduction begins", "Light walking encouraged"]
                  },
                  {
                    period: "Month 2-3",
                    title: "Active Recovery",
                    activities: ["Return to light exercises", "Most swelling resolves", "Scar care begins", "Normal daily activities resume"]
                  },
                  {
                    period: "Month 4-6",
                    title: "Final Results",
                    activities: ["Full exercise regimen", "Final contour visible", "Scars mature and fade", "Complete healing achieved"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention & Aftercare */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Post-operative Care & Maintenance
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Immediate Post-op Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Wear compression garment 24/7 for 4-6 weeks</li>
                      <li style={{ marginBottom: "10px" }}>Sleep in slightly bent position to reduce tension on incision</li>
                      <li style={{ marginBottom: "10px" }}>Avoid heavy lifting and strenuous activities for 6-8 weeks</li>
                      <li>Maintain proper drain care and attend all follow-up appointments</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Maintenance</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Maintain stable weight through balanced diet and exercise</li>
                      <li style={{ marginBottom: "10px" }}>Practice good scar care with silicone sheets and sun protection</li>
                      <li style={{ marginBottom: "10px" }}>Continue core strengthening exercises after full recovery</li>
                      <li>Stay hydrated and maintain healthy lifestyle habits</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How painful is tummy tuck surgery?",
                  answer: "Tummy tuck surgery involves significant tissue manipulation, so some discomfort is expected during recovery. The procedure is performed under general anesthesia, so you won't feel any pain during the surgery itself. In the first 2-3 days post-operation, patients typically experience moderate pain that is well-managed with prescription pain medication. The sensation is often described as intense muscle soreness similar to an extreme abdominal workout. Most patients transition to over-the-counter pain relievers within 3-5 days. The tightness and discomfort gradually decrease over 2-3 weeks, with most significant pain resolving within the first week. Your surgical team will provide comprehensive pain management strategies, including long-acting local anesthetics during surgery and detailed medication schedules to ensure your comfort throughout recovery. Many patients find the results well worth the temporary discomfort."
                },
                {
                  question: "How long do tummy tuck results last?",
                  answer: "Tummy tuck results are considered permanent for the tissues that are surgically addressed. The excess skin removed and muscles repaired will not return. However, the longevity of your results depends on several factors: Maintaining stable weight (significant weight fluctuations can stretch remaining skin), Future pregnancies (can reverse muscle repair and stretch skin), Aging process (natural skin laxity over time), and Overall lifestyle and health habits. Patients who maintain their weight and follow a healthy lifestyle typically enjoy their tummy tuck results for decades. The muscle repair is permanent, and the removed skin will not grow back. While natural aging will cause some skin loosening over time, the dramatic improvement from surgery remains evident. Most patients consider their tummy tuck a lifelong investment in their appearance and confidence, with results that endure with proper maintenance."
                },
                {
                  question: "What is the recovery time for a tummy tuck?",
                  answer: "Tummy tuck recovery follows a progressive timeline: First 1-2 weeks require significant rest with limited mobility; Weeks 2-4 allow gradual return to light activities and desk work; Weeks 4-6 permit driving and light household tasks; Weeks 6-8 mark return to most normal activities and light exercise; Months 2-3 allow full exercise regimen and strenuous activities; 6 months for complete healing and final results. Most patients take 2-3 weeks off work, depending on their job physical demands. The compression garment must be worn for 4-6 weeks continuously. Drains, if used, are typically removed within 1-2 weeks. Swelling gradually resolves over 3-6 months, with final contour becoming apparent around the 6-month mark. Following your surgeon's specific post-operative instructions is crucial for optimal healing and minimizing complications."
                },
                {
                  question: "Can I get pregnant after a tummy tuck?",
                  answer: "Yes, you can get pregnant after a tummy tuck, but it's generally recommended to complete your family before undergoing the procedure. Pregnancy after tummy tuck can affect your results in several ways: The repaired abdominal muscles may separate again (diastasis recti recurrence), The remaining abdominal skin will stretch during pregnancy, Weight gain may affect your overall contour, and Additional skin laxity may occur post-pregnancy. While many women have healthy pregnancies after tummy tucks, they often require revision surgery to restore their results. If you're planning future pregnancies, it's usually advised to postpone your tummy tuck until after you've completed your family. However, if pregnancy occurs after your tummy tuck, discuss your concerns with both your plastic surgeon and obstetrician to ensure optimal care throughout your pregnancy. Many women successfully maintain good results with proper prenatal care and postpartum recovery."
                },
                {
                  question: "What's the difference between a full tummy tuck and mini tummy tuck?",
                  answer: "The main differences between full and mini tummy tucks involve the extent of correction and surgical approach: A full tummy tuck addresses both upper and lower abdomen, repairs abdominal muscle separation, repositions the belly button, and uses a hip-to-hip incision. It's comprehensive for significant skin excess and muscle weakness. A mini tummy tuck focuses only on the lower abdomen below the navel, does not involve muscle repair typically, leaves the belly button in place, and uses a shorter incision. It's suitable for minor skin laxity in patients with good muscle tone. Key distinctions include: Correction area (full: entire abdomen, mini: lower only), Muscle repair (full: yes, mini: usually no), Belly button (full: repositioned, mini: unchanged), Scar length (full: longer, mini: shorter), Recovery time (full: 6-8 weeks, mini: 2-4 weeks), and Ideal candidates (full: significant excess, mini: mild concerns). Your surgeon will recommend the appropriate procedure based on your anatomy and goals."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready for Tummy Tuck Transformation?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert surgical team provides comprehensive tummy tuck procedures with muscle repair and natural-looking results.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Plastic Surgery: <strong>080-6541-7705</strong> | Body Contouring: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default TummyTuckSurgery;